import FouModal from 'components/overlay/fou-modal/'
import FouContainer from 'components/tools/fou-container/'
import FouGrid from 'components/layout/fou-grid/'
import FouGroup from 'components/layout/fou-group/'
import FouPicture from 'components/tools/fou-picture/'
import LoadAnimation from 'components/animations/loading'
import MyfontsShortCircleIcon from 'components/icons/myfonts-short-circle/'
import ErrorIcon from 'components/icons/error/'
import OkIcon from 'components/icons/ok/'
import TrashIcon from 'components/icons/trash/'
import WarningIcon from 'components/icons/warning/'
import Draggable from 'vuedraggable'
import { TimeoutUtil } from 'src/utils/helper/timer'
import { DraggableObject } from 'src/utils/objects/draggable'
import Methods from './results.methods.js'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import SubmissionMethods from 'src/pages/submissions/script/common.methods'
import Validator from 'src/pages/submissions/components/validator/'
import { mapGetters, mapActions } from 'vuex'
import Externalsku from './../externalsku'
import smartSorting from './../smart-sorting'
import CustomerMessage from './../customerMessage'
import { SubmissionObject , errors as submissionErrors } from 'src/pages/submissions/script/common.data'
import BinaryValidationIcons from './../binaryValidationIcons'
import WarningTriangleIcon from 'components/icons/warning-triangle/'
import TextField from 'src/components/form/text-field/index.vue'
import { useForm } from 'vee-validate'
import StyleTextBox from './../style-textbox'
import { isEmpty } from 'lodash'
export default {
  name: 'LiveResults',

  components: {
    FouModal,
    FouContainer,
    FouGroup,
    FouPicture,
    ...FouGrid,
    LoadAnimation,
    MyfontsShortCircleIcon,
    ErrorIcon,
    OkIcon,
    WarningIcon,
    Draggable,
    Validator,
    Externalsku,
    CustomerMessage,
    BinaryValidationIcons,
    WarningTriangleIcon,
    smartSorting,
    TrashIcon,
    TextField,
    StyleTextBox
  },

  data() {
    return {
      results: {
        items: [],
        timer: TimeoutUtil()
      },
      isDragDropDisable: false,
      family: {
        name: null,
        editing: false,
        uniqueName: null
      },
      fouDraggable: DraggableObject(this),
      unsubscribe: null,
      binaries2compare: {},
      ready: {
        name: this.$options.name,
        state: 'unset'
      },
      deleteText: '',
      fontURI: process.env.MY_FONTS_URL,
      stepsHasErrorsUrl: this.$route.params.stepsHasErrorsUrl,
      ...SubmissionObject
    }
  },
  setup() {
    const { errors, validate, setErrors } = useForm()
    return {
      errors,
      validate,
      setErrors
    }
  },

  computed: {
    ...SubmissionComputed,
    ...mapGetters('binaries', ['getBinaryFontRenderSrc']),
    ...mapGetters('auth', ['hasRole', 'user']),
    ...mapGetters('binaries', {
      allBinaries: ['list'],
      newBinaries: ['newList']
    }),
    validateCustomerMsg() {
      if (this.submission.status === 'in_correction' && this.submission.isLive) {
        return 'required|script_tag_validate'
      }
    },
    styleNameErrors() {
      return Object.keys(this.errors)
        .filter(error => error.includes('style name'))
        .map(error => this.errors[error])
    },
    isDisabledDeleteButton() {
      return this.deleteText !== 'DELETE'
    }
  },

  watch: {
    isErrorOnFont: {
      handler(newVal) {
        this.removeFontValidationError(newVal)
      },
      immediate: true
    },
    errors: {
      handler(newVal) {
        if (!isEmpty(newVal)) {
          this.handleErrorsForValidation(newVal)
        }
      },
      immediate: true
    }
  },

  methods: {
    ...Methods,
    ...SubmissionMethods,
    ...mapActions('overlay', ['hide', 'show']),
    draggableStart() {
      this.fouDraggable.start()
    },
    draggableEnd() {
      this.fouDraggable.end()
    },
    validateErrorOnFont(inValid) {
      this.removeFontValidationError(inValid)
    },
    removeFontValidationError(inValid) {
      if (inValid) {
        this.setErrors({
          'font validation upload': this.$t('pages.submissions.components.validator.general_message')
        })
      } else {
        submissionErrors.value = submissionErrors.value.filter(error => !Object.hasOwn(error, 'font validation upload'))
      }
      submissionErrors.value = [...new Set(submissionErrors.value.map(itm => JSON.stringify(itm)))].map(i =>
        JSON.parse(i)
      )
    },
    openFoundryLink() {
      window.open(
        'https://foundrysupport.monotype.com/hc/en-us/articles/360035663991-Updating-existing-font-files-in-Monotype-Font-Platform',
        '_blank',
        'noopener'
      )
    },
    renderDeleteButton(evt, key) {
      const modalOptions = {}
      modalOptions.cols = this.$refs.delLiveFont[key]?.cols
      modalOptions.content = this.$refs.delLiveFont[key].$slots.content
      this.show(modalOptions)
    },
    unsetDeleteTxt() {
      this.deleteText = ''
    },
    handleErrorsForValidation(newVal) {
      for (const key in newVal) {
        submissionErrors.value.push({ [key]: newVal[key] })
      }
      if (this.removeFontId) {
        this.removeErrorFromSubmissionErrors(`external sku ${this.removeFontId} upload`)
        this.removeErrorFromSubmissionErrors(`style name ${this.removeFontId} upload`)
      }
      this.results.items.forEach(item => {
        if (!Object.hasOwn(this.errors, `style name ${item.id} upload`)) {
          submissionErrors.value = submissionErrors.value.filter(
            err => !err.hasOwnProperty(`style name ${item.id} upload`)
          )
        }
      })
      if (!this.isFontInvalid) {
        submissionErrors.value = submissionErrors.value.filter(
          error => !error.hasOwnProperty('font validation upload')
        )
      }
      submissionErrors.value = [...new Set(submissionErrors.value.map(itm => JSON.stringify(itm)))].map(i =>
        JSON.parse(i)
      )
    }
  },

  created() {
    this.addReadyState()
    this.setSubmissionBuild({
      before: this.buildSubmission
    })
    this.resultsFamilyInit()
    this.$events?.$on('remove:binary', binaryArray => {
      this.removeLiveBinary(binaryArray)
    })
    this.$events?.$on('cancel:live-modal', delBinArray => {
      this.cancelLiveResults(delBinArray)
    })
    this.$events?.$on('deleteLiveFont', () => {
      this.unsetDeleteTxt()
    })
    this.$events?.$on('trigger:validate', () => {
      this.validate()
    })
  },

  beforeUnmount() {
    this.results.timer.clear()
    this.unsubscribe()
    this.$events.$off('remove:binary')
    this.$events.$off('cancel:live-modal')
    this.$events.$off('deleteLiveFont')
    this.$events?.$off('trigger:validate')
  },
}
